import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";
import { OfflineSyncService } from "../storageService/offlineSyncService";

const LoadRDOAccountVisitations = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/RDOAccountVisitation/GetRDOAccountVisitations',
        {
            SiteId: defaultSite.id,
            DateStart: date,
            DateEnd: date
        }
    )
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "GetRDOAccountVisitations");
            offlineService.addOffline(defaultSite.id, "GetRDOAccountVisitations", result.rdoAccountVisits);
        },
            (error) => {
                console.log(error);
            });
};

const LoadRDOSectionsForAll = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/RDOAccountVisitation/GetRDOSectionsForAll',
        {
            SiteId: defaultSite.id,
            DateStart: date,
            DateEnd: date
        }
    )
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "GetRDOSectionsForAll");
            offlineService.addOffline(defaultSite.id, "GetRDOSectionsForAll", result.RDOAccountVisitSectionList);
        },
            (error) => {
                console.log(error);
            });
};

const LoadRDOAndDirector = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/RDOAccountVisitation/GetRDOAndDirector', { houseCode: Number(defaultSite.houseCode[0]) })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "GetRDOAndDirector");
            offlineService.addOffline(defaultSite.id, "GetRDOAndDirector", result.rdoDirector);
        },
            (error) => {
                console.log(error);
            });
};

const LoadRDOParameters = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/RDOAccountVisitation/GetRDOParameters', { houseCode: Number(defaultSite.houseCode[0]) })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "GetRDOParameters");
            offlineService.addOffline(defaultSite.id, "GetRDOParameters", result.rdoParameter);
        },
            (error) => {
                console.log(error);
            });
};

const LoadRDOAccountVisitTemplate = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/RDOAccountVisitation/GetRDOAccountVisitTemplate', { houseCode: Number(defaultSite.houseCode[0]) })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "GetRDOAccountVisitTemplate");
            offlineService.addOffline(defaultSite.id, "GetRDOAccountVisitTemplate", result.rdoSectionOptionTemplate);
        },
            (error) => {
                console.log(error);
            });
};

const GetRDOSections = async (siteId,rdoAccountVisitId) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "GetRDOSectionsForAll");
    return offlineResult.OfflineData.filter(x => x.RDOAccountVisitId === rdoAccountVisitId);
};

const SaveRDOSectionOfflineData = async (siteId, entityId, keyName, param, url, isOnline, remove) => {
    const offlineSyncService = new OfflineSyncService();

    if (entityId.toString().length <= 12 && !isOnline) {
        let exist = await offlineSyncService.getByNameAndEntityId(entityId, keyName);
        if (exist) {
            offlineSyncService.updateById(exist.Id, param);
        }
        else {
            //add new 
            offlineSyncService.add(siteId, entityId, url, keyName, param);
        }
    }

    UpdateOfflineData(siteId, param.RDOAccountVisitDto, remove);
    UpdateRDOSectionsForAllOfflineData(siteId, param.RDOAccountVisitSectionDto, remove);
};

const UpdateRDOSectionsForAllOfflineData = async (siteId, item, remove) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "GetRDOSectionsForAll");
    const data = offlineResult.OfflineData;
    const index = data.findIndex(d => d.Id === item.Id);

    if (remove) {
        offlineResult.OfflineData.splice(index, 1);
    }
    else if (index === -1)
        offlineResult.OfflineData.push(item);
    else {
        offlineResult.OfflineData[index] = item;
    }

    offlineService.updateOfflineByName(siteId, "GetRDOSectionsForAll", offlineResult.OfflineData);
};

const UpdateOfflineData = async (siteId, item, remove) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "GetRDOAccountVisitations");
    const data = offlineResult.OfflineData;
    const index = data.findIndex(d => d.Id === item.Id);

    if (remove) {
        offlineResult.OfflineData.splice(index, 1);
    }
    else if (index === -1)
        offlineResult.OfflineData.push(item);
    else {
        offlineResult.OfflineData[index] = item;
    }

    offlineService.updateOfflineByName(siteId, "GetRDOAccountVisitations", offlineResult.OfflineData);
};

export { LoadRDOAccountVisitations, LoadRDOSectionsForAll, LoadRDOAndDirector, LoadRDOParameters, LoadRDOAccountVisitTemplate, SaveRDOSectionOfflineData, GetRDOSections};
